var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralAid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 36.066,
    viewBox: "0 0 40 36.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "first_aid_kit",
    transform: "translate(-3 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48128",
    "data-name": "Group 48128",
    transform: "translate(3 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48125",
    "data-name": "Group 48125",
    transform: "translate(5.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55280",
    "data-name": "Path 55280",
    d: "M24.574,25H19.328a.328.328,0,0,0-.328.328v1.311a.328.328,0,0,0,.328.328h5.246a.328.328,0,0,0,.328-.328V25.328A.328.328,0,0,0,24.574,25Z",
    transform: "translate(-19 -19.754)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55281",
    "data-name": "Path 55281",
    d: "M96.574,25H91.328a.328.328,0,0,0-.328.328v1.311a.328.328,0,0,0,.328.328h5.246a.328.328,0,0,0,.328-.328V25.328A.328.328,0,0,0,96.574,25Z",
    transform: "translate(-67.393 -19.754)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55282",
    "data-name": "Path 55282",
    d: "M53.82,9H45.951A2.954,2.954,0,0,0,43,11.951v3.934a.328.328,0,0,0,.328.328H45.3a.328.328,0,0,0,.328-.328V11.951a.336.336,0,0,1,.328-.328H53.82a.336.336,0,0,1,.328.328v3.934a.328.328,0,0,0,.328.328h1.967a.328.328,0,0,0,.328-.328V11.951A2.954,2.954,0,0,0,53.82,9Z",
    transform: "translate(-35.131 -9)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55283",
    "data-name": "Path 55283",
    d: "M38.738,29H7.262A4.267,4.267,0,0,0,3,33.262V54.246a4.267,4.267,0,0,0,4.262,4.262H38.738A4.267,4.267,0,0,0,43,54.246V33.262A4.267,4.267,0,0,0,38.738,29Z",
    transform: "translate(-3 -22.443)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55284",
    "data-name": "Path 55284",
    d: "M41.82,41a10.82,10.82,0,1,0,10.82,10.82A10.832,10.832,0,0,0,41.82,41Z",
    transform: "translate(-21.82 -30.508)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55285",
    "data-name": "Path 55285",
    d: "M56.443,57.59H52.18V53.328A.328.328,0,0,0,51.852,53H47.918a.328.328,0,0,0-.328.328V57.59H43.328a.328.328,0,0,0-.328.328v3.934a.328.328,0,0,0,.328.328H47.59v4.262a.328.328,0,0,0,.328.328h3.934a.328.328,0,0,0,.328-.328V62.18h4.262a.328.328,0,0,0,.328-.328V57.918A.328.328,0,0,0,56.443,57.59Z",
    transform: "translate(-29.885 -38.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48126",
    "data-name": "Group 48126",
    transform: "translate(1.311 10.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55286",
    "data-name": "Path 55286",
    d: "M7.328,46.246A.328.328,0,0,1,7,45.918v-4.59a.328.328,0,0,1,.656,0v4.59A.328.328,0,0,1,7.328,46.246Z",
    transform: "translate(-7 -41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48127",
    "data-name": "Group 48127",
    transform: "translate(1.311 17.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55287",
    "data-name": "Path 55287",
    d: "M7.328,62.967A.328.328,0,0,1,7,62.639V61.328a.328.328,0,1,1,.656,0v1.311A.328.328,0,0,1,7.328,62.967Z",
    transform: "translate(-7 -61)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralAid);
export default __webpack_public_path__ + "static/media/university-general-aid.17e97b19ef6727875199b61bf85318ac.svg";
export { ForwardRef as ReactComponent };